export const initialState = {
  PG: {
    pg_name: "",
    preferred_tenant: "",
    suitable_for: [],
    total_floors: "",
    room_sharing_type: [],
    capacity_and_availability: {},
    furnish_type: "",
    covered_parking: 0,
    open_parking: 0,
    property_managed_by: "",
    manager_stays_at_pg: "",
    pricing: "",
    maintenance_charges: 0,
    booking_amount: 0,
    other_charges: 0,
    negotiable: false,
    is_electricity_and_water_charge: false,
    included_services: [],
    meals_available: "",
    meal_type: "",
    meal_on_weekends: [],
    meal_on_weekdays: [],
    notice_period: 0,
    lock_in_period: {},
    location: {},
    amenities: [],
    pg_rules: [],
    common_areas: [],
    photos: [],
    description: "",
    gate_timing: "",
  },
  commercial_property: {
    ad_type: "",
    construction_status: "",
    age_of_property: "",
    area: { unit: "square_feet" },
    description: "",
    location: {},
    available_from:"",
    approx_price:"",
    is_on_lease:false,
  },
  office:{
    ownership:"",
    property_condition:"",
    total_cabins:"",
    total_floors:"",
    total_meeting_rooms:"",
    total_seats:"",
    your_floor:"",
    zone_type:"",
  },
  showroom:{
    age_of_property:"",
    available_from:"",
    ownership:"",
  },
  retail_shop:{
   ownership:"",
  },
  warehouse:{
  ownership:"",
  },
  residential_property: {
    ad_type: "",
    bathrooms: "",
    balconies: "",
    additional_rooms: [],
    location: {},
    photos: [],
    area: { unit: "square_feet" },
    age_of_property:"",
    approx_price:"",
    available_from:"",
    description:"",
    furnish_type:"",
    furnish_type_items: [],
  is_on_lease:false,
  preferred_tenant:[],
  total_floors:"",
  property_condition:"",
  },
 "flat/apartment":{
 // age_of_property:"",
  //approx_price:"",
  //available_from:"",
  bhk:"",
  your_floor:"",
  
 },
 independent_house:{
  bhk:"",
 },
 "vila/farm_house":{
  bhk:"",
 },
 "1_rk_studio":{
  your_floor:"",
 },
 floor:{
  bhk:"",
  your_floor:"",
 },
  plot: {
    possession_period: { period: "", month: "" },
    area: { unit: "square_feet" },
    width_of_facing_road: { unit: "feet" },
    location: {},
    boundary_wall: false,
    corner_plot: false,
    is_hot_deal: false,
    dimension: {},
    financing_available: false
  },
  need_flat: {
    date_of_birth: '',
    gender: '',
    occupation: '',
    description: '',
    partner_gender: '',
    min_partner_age: 0,
    max_partner_age: 0,
    partner_occupation: [],
    min_approx_price: 0,
    max_approx_price: 0,
    negotiable: false,
    photos: [],
    location: {},
    need_to_shift: '',
    min_partner_age_value: 0,
    max_partner_age_value: 0,
    min_approx_price_value: 0,
    max_approx_price_value: 0,
    studying: '',
    designation: '',
    languages: '',
    hobbies: '',
    preferences: [],
    social_links: {}
  },
  need_flatmate: {
    available_from: '',
    total_rooms: 0,
    your_floor: '',
    total_floors: 0,
    available_rooms: '',
    furnish_type: '',
    date_of_birth: '',
    gender: '',
    description: '',
    min_partner_age: 0,
    max_partner_age: 0,
    min_approx_price: 0,
    max_approx_price: 0,
    partner_gender: '',
    partner_occupation: [],
    negotiable: false,
    preferences: [],
    amenities: [],
    photos: [],
    location: {},
    bhk: '',
    room_details: [],
    furnish_type_items: [],
    electricity_charges_included: false,
    maintenance_charges: 0,
    booking_amount: 0,
    other_charges: 0,
    security_deposit: {
      type: '',
      amount: '0',
      month: '',
    },
    min_partner_age_value: 0,
    max_partner_age_value: 0,
    occupation: '',
    studying: '',
    designation: '',
    languages: '',
    hobbies: '',
    social_links: {},
  }
};
